import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConsultorService extends BaseService {
  private baseUrl = '/consultor';

  public createAccess(body: any): Observable<any> {
    return this.basePost(`${this.baseUrl}`, body);
  }

}
